import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";

import { useReport } from "../../context/report";

import { useEffect, useState } from "react";

export function TesteGomaRolada() {
    const [dados, setDados] = useState({
        roladas: [],
        rolos: []
    })
    const [eficiencia, setEficiencia] = useState("");

    const { data } = useReport();

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData[props.field]);
    }

    const columnStyle = {
        width: `${100 / 8}%`,
        borderWidth: 1,
    }

    useEffect(() => {
        if (parseInt(eficiencia)) {
            let copy = { ...data };

            let rolos = copy.rolos.filter((element) => {
                return element.eficiencia_tear <= eficiencia;
            });

            let roladas = copy.roladas.filter((element) => {
                return element.eficiencia_tear <= eficiencia;
            });

            copy.roladas = roladas;
            copy.rolos = rolos;

            setDados(copy);
        } else {
            setDados(data);
        }
    }, [eficiencia]);

    useEffect(() => {
        setDados(data);
    }, [data]);

    return (
        <div>
            <div className="p-d-flex p-flex-row">
                <InputText
                    className="p-m-2"
                    onChange={e => setEficiencia(e.target.value)}
                    placeholder="Eficiência abaixo de"
                    type="number"
                    value={eficiencia}
                />
            </div>
            <Panel header="RELATÓRIO DE QUEBRAS POR ROLADA" toggleable>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={dados.roladas}
                >
                    <Column header="Rolada" field="rolada" sortable style={columnStyle} />
                    <Column header="Eficiência" field="eficiencia_tear" body={formatNumber} sortable style={columnStyle} />
                    <Column header="Metragem" field="metros" sortable body={(rowData) => {
                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData.metros);
                    }} style={columnStyle} />
                    <Column header="Urdume" field="urdume" sortable style={columnStyle} />
                    <Column header="Trama" field="trama" sortable style={columnStyle} />
                    <Column header="Urdume CMPX" field="urdume_cmpx" body={formatNumber} sortable style={columnStyle} />
                    <Column header="Trama CMPX" field="trama_cmpx" body={formatNumber} sortable style={columnStyle} />
                    <Column header="Quebras CMPX" field="quebras_cmpx" body={formatNumber} sortable style={columnStyle} />
                </DataTable>
            </Panel>

            <Panel header="RELATÓRIO DE QUEBRAS POR ROLO" toggleable>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    filterDisplay="row"
                    responsiveLayout="scroll"
                    size="small"
                    value={dados.rolos}
                >
                    <Column header="Rolo" field="rolo" filter showFilterMenu={false} sortable style={columnStyle} />
                    <Column header="Eficiência" field="eficiencia_tear" body={formatNumber} sortable style={columnStyle} />
                    <Column header="Metragem" field="metros" sortable body={(rowData) => {
                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData.metros);
                    }} style={columnStyle} />
                    <Column header="Urdume" field="urdume" sortable style={columnStyle} />
                    <Column header="Trama" field="trama" sortable style={columnStyle} />
                    <Column header="Urdume CMPX" field="urdume_cmpx" body={formatNumber} sortable style={columnStyle} />
                    <Column header="Trama CMPX" field="trama_cmpx" body={formatNumber} sortable style={columnStyle} />
                    <Column header="Quebras CMPX" field="quebras_cmpx" body={formatNumber} sortable style={columnStyle} />
                </DataTable>
            </Panel>
        </div>
    )
}